import { useCallback, useState } from 'react';
import type { TestimonialsFormValues } from 'src/routes/TestimonialsForm/types';

export type UseTestimonialsFormCache = ReturnType<
  typeof useTestimonialsFormCache
>;

export const useTestimonialsFormCache = () => {
  const [formValueCache, setFormValueCache] = useState<
    TestimonialsFormValues | undefined
  >(undefined);

  const resetFormValueCache = useCallback(() => {
    setFormValueCache(undefined);
  }, []);

  const saveFormValueCache = useCallback(
    (values: TestimonialsFormValues): TestimonialsFormValues => {
      setFormValueCache(values);
      return values;
    },
    [],
  );

  return {
    formValueCache,
    saveFormValueCache,
    resetFormValueCache,
  };
};
